<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import BankingImportsWorkspace from '@/views/Banking/Imports/BankingImportsWorkspace.vue'

setPageTitle(PageMeta.Banking.Imports.Title)
definePage({ meta: PageMeta.Banking.Imports.Meta })
</script>

<template>
  <BankingImportsWorkspace />
</template>
